/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ErrorMessage, Field, Form, Formik } from 'formik'
import React from 'react'
import {Modal} from 'react-bootstrap-v5'
import { NumericFormat } from 'react-number-format'
import * as Yup from 'yup'
import { revertPriceNumner } from '../../../selectors'
import { updateOpeningConfig } from '../../store/StoreCRUD'
import { removeTrailingZeros, Toast } from '../../../modules/common/helper'
import { useDispatch } from 'react-redux'
import * as auth from '../../../modules/auth/redux/AuthRedux'
import { UserLoggedIn } from '../../../hooks/PermissionChecker'
import { IStoreModel } from '../../../models/StoreModel'
import { AsyncSelect2 } from '../../../../_metronic/partials/select/AsyncSelect2'
import { GET_TAXGROUP_OPTIONS } from '../../../constants/endpoints'
import { TAX_BY_PROFITS_AMOUNT, TAX_BY_SALES_AMOUNT } from '../../../constants/common'

type Props = {
  show: boolean
  handleClose: () => void
  handleShowShareProductRules: () => void
  isApproveShare?: boolean
}

const addSchema = Yup.object().shape({
    bank_opening: Yup.number()
        .typeError('Giá trị phải là số')
        .required('Trường này là bắt buộc'),
    cash_opening: Yup.number()
        .typeError('Giá trị phải là số')
        .required('Trường này là bắt buộc'),
    tax_group_id: Yup.number().min(1)
        .required('Trường này là bắt buộc'),
})

const OpeningConfigModal: React.FC<Props> = ({ show,  handleClose, handleShowShareProductRules, isApproveShare}) => {
    const dispatch = useDispatch();
    const user = UserLoggedIn();
    let config = user.store?.open_store_config;
    let initValues: any = {
        report_period: config?.report_period ?? 'monthly',
        bank_opening: config?.bank_opening ?? 0,
        cash_opening: config?.cash_opening ?? 0,
        tax_group_id: config?.tax_group?.id,
        tax_group: config?.tax_group ?? null,
        tax_calc_by: config?.tax_calc_by ?? null,
        number_format: config?.number_format ?? 'default',
        allow_share_products: isApproveShare ?? (user.store?.allow_share_products ?? 0),
        is_stock_alert: config?.is_stock_alert ?? 1,
        use_auto_alocate_ability: config?.use_auto_alocate_ability ?? 0
    }
    const onSubmit = async (values: any) => {
        try {
            const {data: data} = await updateOpeningConfig(values);
            let storeData: IStoreModel = data?.data?.store ?? null;
            if (storeData) {
                let newUser =  {...user, store: storeData};
                dispatch(auth.actions.setUser(newUser))
            }
            Toast.fire({
                icon: 'success',
                title: 'Cập nhật cấu hình thành công'
            });
            handleClose();
        } catch (error) {
            console.log(error);
            Toast.fire({
                icon: 'error',
                title: 'Cập nhật cấu hình thất bại'
            });
        }
    };
    
    return (
        <Modal
            show={show}
            onHide={handleClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header className='d-flex'>
                <Modal.Title>Thiết lập cấu hình</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-10">
                <Formik enableReinitialize validationSchema={addSchema} initialValues={initValues} onSubmit={onSubmit}>
                    {({ values, handleChange, setValues }) => (
                        <Form>
                            <div className="d-flex flex-column  gap-5 pt-3">
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className='form-label required' htmlFor={'tax_group_id'}>
                                        Nhóm ngành 
                                    </label>
                                    <div className="col-12">
                                        <AsyncSelect2
                                            sourceUrl={`${GET_TAXGROUP_OPTIONS}`}
                                            defaultOptions
                                            default
                                            value={{
                                                value: values.tax_group?.id ?? null,
                                                label: values.tax_group?.name ?? null
                                            }}
                                            name='tax_group_id' 
                                            onChange={(selectedOption: any) => {
                                                setValues({
                                                    ...values,
                                                    tax_group_id: selectedOption?.value,
                                                    tax_group: {
                                                        id: selectedOption?.value,
                                                        name: selectedOption?.label
                                                    }
                                                });
                                            }}
                                        />
                                        <ErrorMessage name={'tax_group_id'} className='text-danger' component='span' />
                                    </div>
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">Số đầu kỳ ngân hàng</label>
                                    <NumericFormat
                                      thousandSeparator=","
                                      name='bank_opening'
                                      className='form-control form-control-sm'
                                      required
                                      value={removeTrailingZeros(values.bank_opening ?? 0)}
                                      onBlur={(e) => {
                                          handleChange({target: {name: 'bank_opening', value: revertPriceNumner(e.target.value)}});
                                      }}
                                    />
                                    <ErrorMessage name='bank_opening' className='text-danger' component='span' />
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">Số đầu kỳ tiền mặt</label>
                                    <NumericFormat
                                      thousandSeparator=","
                                      name='cash_opening'
                                      value={removeTrailingZeros(values.cash_opening ?? 0)}
                                      className='form-control form-control-sm'
                                      required
                                      onBlur={(e) => {
                                          handleChange({target: {name: 'cash_opening', value: revertPriceNumner(e.target.value)}});
                                      }}
                                    />
                                    <ErrorMessage name='cash_opening' className='text-danger' component='span' />
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                  <label className="form-label">Kỳ báo báo thuế</label>
                                  <Field
                                    as='select'
                                    name='report_period'
                                    className='form-select'
                                    required
                                  >
                                      <option value="monthly">Tháng</option>
                                      <option value="quarterly">Quý</option>
                                      <option value="yearly">Năm</option>
                                  </Field>
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className='d-flex cursor-pointer mb-2'>
                                        <span className='form-check form-check-custom form-check-solid  me-3'>
                                            <Field
                                                className='form-check-input'
                                                type='radio'
                                                name='tax_calc_by'
                                                value={TAX_BY_SALES_AMOUNT}
                                                onChange={(e: any) => {
                                                    handleChange(e);
                                                }}
                                            />
                                        </span>
                                        <span className='d-flex align-items-center me-2'>Tính thuế theo doanh thu</span>
                                    </label>
                                    <label className='d-flex cursor-pointer mb-0'>
                                        <span className='form-check form-check-custom form-check-solid  me-3'>
                                            <Field
                                                className='form-check-input'
                                                type='radio'
                                                name='tax_calc_by'
                                                value={TAX_BY_PROFITS_AMOUNT}
                                                onChange={(e: any) => {
                                                    handleChange(e);
                                                }}
                                            />
                                        </span>
                                        <span className='d-flex align-items-center me-2'>Tính thuế theo lợi nhuận</span>
                                    </label>
                                </div>
                                <div className='fv-row flex-row-fluid fv-plugins-icon-container'>
                                    <div className='form-check form-check-custom mb-0'>
                                        <input
                                            type='checkbox'
                                            className='form-check-input'
                                            defaultChecked={values.number_format === 'default'}
                                            onChange={(e) => {
                                                handleChange({target: {name: 'number_format', value: e.target.checked ? 'default' : 'decimal_2'}});
                                            }}
                                            id='number-format'
                                        />
                                        <label className='form-check-label' htmlFor={'number-format'}>
                                            Làm tròn số
                                        </label>
                                    </div>
                                </div>
                                <div className='fv-row flex-row-fluid fv-plugins-icon-container'>
                                    <div className='form-check form-check-custom mb-0'>
                                        <input
                                            type='checkbox'
                                            className='form-check-input'
                                            defaultChecked={values.is_stock_alert == 1}
                                            onChange={(e) => {
                                                handleChange({target: {name: 'is_stock_alert', value: e.target.checked ? 1 : 0}});
                                            }}
                                            id='is_stock_alert'
                                        />
                                        <label className='form-check-label' htmlFor={'is_stock_alert'}>
                                            Cảnh báo tồn kho không đủ 
                                        </label>
                                    </div>
                                </div>
                                <div className='fv-row flex-row-fluid fv-plugins-icon-container'>
                                    <div className='form-check form-check-custom mb-3 align-items-start'>
                                        <input
                                            type='checkbox'
                                            className='form-check-input'
                                            checked={values.use_auto_alocate_ability == 1}
                                            onChange={(e) => {
                                                handleChange({target: {name: 'use_auto_alocate_ability', value: e.target.checked ? 1 : 0}});
                                            }}
                                            id='use_auto_alocate_ability'
                                        />
                                        <label className='form-check-label'>
                                            <span className='fw-bold'>
                                                Tự động phân bổ thu/chi công nợ (FIFO) 
                                            </span>
                                            <p className='mb-0 text-muted'>Tự động phân vào đơn hàng/phiếu nhập theo nguyên tắc FIFO khi tạo phiếu thu/chi công nợ</p>
                                        </label>
                                    </div>
                                </div>
                                <div className='fv-row flex-row-fluid fv-plugins-icon-container'>
                                    <div className='form-check form-check-custom mb-3 align-items-start'>
                                        <input
                                            type='checkbox'
                                            className='form-check-input'
                                            checked={values.allow_share_products == 1}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    handleShowShareProductRules()
                                                    return;
                                                }
                                                handleChange({target: {name: 'allow_share_products', value: 0}});
                                            }}
                                            id='allow_share_products'
                                        />
                                        <label className='form-check-label'>
                                            <span className='fw-bold'>
                                                Kho dữ liệu sản phẩm SENTO 
                                                <i 
                                                    className='bi bi-info-circle-fill text-primary fs-3 ms-1' 
                                                    onClick={handleShowShareProductRules}
                                                ></i>
                                            </span>
                                            <p className='mb-0 text-muted'>Sử dụng kho Barcode có sẵn - Tạo sản phẩm nhanh - Quản lý kho hiệu quả</p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex mb-4 justify-content-between pt-8'>
                                <button className="btn btn-bg-secondary" type="button" onClick={() => handleClose()}>Hủy</button>
                                <button className="btn btn-bg-success" type="submit">Lưu</button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}
export {OpeningConfigModal}
